import React from "react";
import { API, graphqlOperation } from "aws-amplify";
import Tooltip from "../_shared/components/Tooltip";

const rowFields = [
  { label: "3M UST", key: "ust_3m", key2: "USGG3M Index" },
  { label: "3M LIBOR", key: "libor_3m", key2: "US0003M Index" },
  { label: "2Y UST", key: "ust_2y", key2: "USGG2YR Index" },
  { label: "5Y UST", key: "ust_5y", key2: "USGG5YR Index" },
  { label: "10Y UST", key: "ust_10y", key2: "USGG10YR Index" },
  { label: "30Y UST", key: "ust_30y", key2: "USGG30YR Index" },
  { label: "2Y-10Y UST SPREAD", key: "ust_spread_2y_10y", key2: "USYC2Y10 Index" },
  { label: "IG SPREAD (BBB - 10Y UST)", key: "ig_spread", key2: "CSI BBB Index" },
  { label: "5Y BREAKEVEN", key: "breakeven_5y", key2: "USGGBE05 Index" },
];

const defaultData = {
  rows: rowFields.map((obj) => {
    return {
      position: obj.label,
      px: 0,
      oneDay: 0,
      fiveDay: 0,
      oneMonth: 0,
      threeMonth: 0,
      high: 0,
      low: 0,
      threeYear: 0,
      fiveYear: 0,
    };
  }),
};

export default function RatesAndSpreads(props) {
  const [data, setData] = React.useState(defaultData);

  React.useEffect(() => {
    refresh();
  }, []);

  React.useEffect(() => {
    if (props.reload) {
      setData(defaultData);
      refresh();
    }
  }, [props.reload]);

  const refresh = async () => {
    const data = (
      await API.graphql(
        graphqlOperation(
          `{python_scripts_cache_by_pk(id: "ratesAndSpreads") {data}}`,
        ),
      )
    ).data.python_scripts_cache_by_pk.data;

    setData({
      rows: rowFields.map((obj) => {
        return {
          position: obj.label,
          px: data[obj.key2]["px"],
          oneDay: data[obj.key2]["1d"],
          fiveDay: data[obj.key2]["5d"],
          oneMonth: data[obj.key2]["1m"],
          threeMonth: data[obj.key2]["3m"],
          high: data[obj.key2]["max"],
          low: data[obj.key2]["min"],
          threeYear: data[obj.key2]["3yavg"],
          fiveYear: data[obj.key2]["5yavg"],
        };
      }),
    });
  };
  function greaterThanZero(num) {
    if (num === 0) {
      return "white";
    }
    return num > 0 ? "green" : "red";
  }

  function addParenthesis(value) {
    if (value < 0) {
      return (
        "(" +
        Math.abs(value).toLocaleString("en-US", {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        }) +
        ")"
      );
    } else {
      return value.toLocaleString("en-US", {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      });
    }
  }

  const tableData = data.rows.map((row, i) => {
    return (
      <div className="info-row" key={i}>
        <div className="cell-first">{row.position}</div>
        <div className={`cell-info ${greaterThanZero(row.px)}`}>
          {row.px.toFixed(3)}
        </div>
        <div className={`cell-info ${greaterThanZero(row.oneDay)}`}>
          {addParenthesis(row.oneDay)}
        </div>
        <div className={`cell-info ${greaterThanZero(row.fiveDay)}`}>
          {addParenthesis(row.fiveDay)}
        </div>
        <div className={`cell-info ${greaterThanZero(row.oneMonth)}`}>
          {addParenthesis(row.oneMonth)}
        </div>
        <div className={`cell-info ${greaterThanZero(row.threeMonth)}`}>
          {addParenthesis(row.threeMonth)}
        </div>
        <div className={`cell-info ${greaterThanZero(row.high)}`}>
          {addParenthesis(row.high)}
        </div>
        <div className={`cell-info ${greaterThanZero(row.low)}`}>
          {addParenthesis(row.low)}
        </div>
        <div className={`cell-info ${greaterThanZero(row.threeYear)}`}>
          {addParenthesis(row.threeYear)}
        </div>
        <div className={`cell-info ${greaterThanZero(row.fiveYear)}`}>
          {addParenthesis(row.fiveYear)}
        </div>
      </div>
    );
  });

  return (
    <section className="section rates-and-spreads">
      <div className="section-title">Rates & Spreads</div>

      <div className="main-headers">
        <div></div>
        <div className="top-header">
          Change
          <div
            data-tip={
              "The basis point change in the position over various time periods."
            }
            className="info-icon-market-insights"
            style={{
              fontWeight: 100,
              color: "white",
              borderColor: "white",
              marginLeft: 5,
            }}
          >
            i
          </div>
        </div>
        <div className="top-header">
          vs. 52 Week
          <div
            data-tip={
              "The current reading versus the 52-week high and low reading."
            }
            className="info-icon-market-insights"
            style={{
              fontWeight: 100,
              color: "white",
              borderColor: "white",
              marginLeft: 5,
            }}
          >
            i
          </div>
        </div>
        <div className="top-header">
          vs. AVG
          <div
            data-tip={
              "The current reading versus the average reading over the specified time period."
            }
            className="info-icon-market-insights"
            style={{
              fontWeight: 100,
              color: "white",
              borderColor: "white",
              marginLeft: 5,
            }}
          >
            i
          </div>
        </div>
      </div>

      <div className="sub-header-rates-and-spreads">
        <div className="sub-header-index">
          <div>Position</div>
        </div>
        <div
          className="sub-header-text"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="justify-center">PX</div>
          <div
            data-tip={"Most recent level downloaded by Longbow."}
            className="info-icon-market-insights"
            style={{
              fontWeight: 100,
              color: "white",
              borderColor: "white",
              marginLeft: 5,
              marginBottom: 5,
            }}
          >
            i
          </div>
        </div>
        <div className="sub-header-text">
          <div className="justify-center">1D</div>
        </div>
        <div className="sub-header-text">
          <div className="justify-center">1W</div>
        </div>
        <div className="sub-header-text">
          <div className="justify-center">1M</div>
        </div>
        <div className="sub-header-text">
          <div className="justify-center">3M</div>
        </div>
        <div className="sub-header-text">
          <div className="justify-center">High</div>
        </div>
        <div className="sub-header-text">
          <div className="justify-center">Low</div>
        </div>
        <div className="sub-header-text">
          <div className="justify-center">3Y</div>
        </div>
        <div className="sub-header-text">
          <div className="justify-center">5Y</div>
        </div>
      </div>
      <div className="rates-and-spreads-content">{tableData}</div>
      <div
        className="rates-and-spreads-content"
        style={{
          borderBottom: "1px solid #666666",
          borderTop: "1px solid #666666",
        }}
      >
        <div className="info-row">
          <div className="transparent">""</div>
          <div className="transparent">""</div>
          <div className="transparent">""</div>
          <div className="transparent">""</div>
          <div className="transparent">""</div>
          <div className="transparent">""</div>
          <div className="transparent">""</div>
          <div className="transparent">""</div>
          <div className="transparent">""</div>
          <div className="transparent">""</div>
        </div>
      </div>
      <Tooltip />
    </section>
  );
}
